import { render } from "./table-box.svg?vue&type=template&id=daae2750?inline"
const script = {}
script.render = render

export default script